define(['t3', 'hy/hy-module', 'hy/hy-utils', 'lodash', 'jquery', 'conditioner', 'lib/doT/doT'], function(T3, BaseModule, hyutils, lodash, $, conditioner, doT) {

    'use strict';

    return BaseModule.addModule('common/modules/opl-footer', function(context) {
        var options = {};
        var moduleEl, $moduleEl;
        var def;
        var templates = {};

        /**
         * Generate menu templates through dot.js Library
         * @param target        - HTML node to load created HTML container
         * @param templateId    - JavaScript template id
         * @param json          - data in JSON format
         * @param type          - include type 'replace' or 'append'
         * @param cb            - callback
         */
        function generateHTML(target, templateId, json, type, cb) {

            if (json === undefined) {
                return;
            }

            var template;
            if (templates['tmpl-' + templateId]) {
                template = templates['tmpl-' + templateId];
            } else {
                var tmp = document.getElementById('tmpl-' + templateId);
                template = doT.template(tmp.text, undefined, def);
                templates['tmpl-' + templateId] = template;
            }
            if (type === 'replace') {
                $moduleEl.find('#' + target).html(template(json)).promise().done(function() {
                    cb && cb();
                });
            } else if (type === 'append') {
                $moduleEl.find('#' + target).append(template(json)).promise().done(function() {
                    cb && cb();
                });
            } else if (type === 'prepend') {
                $moduleEl.find('#' + target).prepend(template(json)).promise().done(function() {
                    cb && cb();
                });
            }
        }


        function initFooter(first, second) {
            $moduleEl.find('.opl-skiplinks').remove();
            generateHTML('footer-wrapper', 'footer-wrapper', OPL.UI.footer, 'prepend', function() {
                createFirstFooterBarDesktop(first);
                createSecondFooterBarDexktop(second);
            });
        }

        function createFirstFooterBarDesktop(obj) {
            OPL.UI.stopModules(document.getElementById('first-footer-bar'));
            generateHTML('first-footer-bar', 'first-footer-bar', obj, 'replace', function() {
                OPL.UI.loadModules(document.getElementById('fixer-for-first-footer-bar'), [{
                    path: 'core/modules/layout-fixer',
                    options: {
                        selectors: ['.js-layout-fixer-group-1']
                    },
                    conditions: 'media:{gt-xsmall}'
                }]);
                OPL.UI.loadModules(document.getElementById('expander-for-first-footer-bar'), [{
                    path: 'core/modules/expander',
                    conditions: 'media:{eq-xsmall}'
                }]);
                var modal = document.getElementById('modal-for-first-footer-bar');
                if (modal) {
                    OPL.UI.loadModules(modal, [{
                        path: 'core/modules/modal',
                        options: {
                            blockTrigger: true,
                            modalClass: "o-modal o-modal--medium o-modal__no-padding"
                        }
                    }]);
                }
            });
        }


        function createSecondFooterBarDexktop(obj) {

            OPL.UI.stopModules(document.getElementById('second-footer-bar'));
            generateHTML('second-footer-bar', 'second-footer-bar', obj, 'replace', function() {
                OPL.UI.loadModules(document.getElementById('expander-for-second-footer-bar'), [{
                    path: 'core/modules/expander',
                    conditions: 'media:{eq-xsmall}'
                }]);
            });
        }



        return {
            init: function() {
                options = lodash.merge({}, options, context.element.options);
                moduleEl = context.getElement();
                $moduleEl = $(moduleEl);

                conditioner.addConditionMonitor('media:{gt-xsmall and eq-small}', function(state) {
                    if (state) {
                        initFooter(OPL.UI.footer.firstFooterBarSmartPlus, OPL.UI.footer.secondFooterBarSmartPlus);
                        var obj = _.filter(OPL.UI.footer.secondFooterBarSmartPlus.children, function(item) {
                            return item.type === 'socialbox';
                        });

                        setTimeout(function() {
                            generateHTML('second-footer-bar-social-box', 'second-footer-bar-social-box', obj, 'replace', function() {});
                        }, 50);
                    }
                });

                conditioner.addConditionMonitor('media:{eq-xsmall}', function(state) {
                    if (state) {
                        initFooter(OPL.UI.footer.firstFooterBarSmart, OPL.UI.footer.secondFooterBarSmart);
                    }
                });

                conditioner.addConditionMonitor('media:{eq-medium}', function(state) {
                    if (state) {
                        initFooter(OPL.UI.footer.firstFooterBarTablet, OPL.UI.footer.secondFooterBarTablet);
                    }
                });
                conditioner.addConditionMonitor('media:{gte-large}', function(state) {
                    if (state) {
                        initFooter(OPL.UI.footer.firstFooterBarDesktop, OPL.UI.footer.secondFooterBarDesktop);
                    }
                });

            },

            destroy: function() {},

            behaviors: []
        };
    });
});